import type { ButtonHTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import FlipUIButton, { type ButtonProps } from '@/shared/components/flip-ui-kit/Button';
import { usePolkadot } from '@/shared/hooks/usePolkadot';

export const ReadonlyButton = (props: ButtonProps) => {
  const { selectedAccount } = usePolkadot();

  return <FlipUIButton {...props} disabled={selectedAccount?.readonly || props.disabled} />;
};

type Require<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

export type ReadonlyHTMLButtonProps = Require<ButtonHTMLAttributes<HTMLButtonElement>, 'type'>;

export const ReadonlyHTMLButton = ({ ...props }: ReadonlyHTMLButtonProps) => {
  const { selectedAccount } = usePolkadot();

  return (
    // eslint-disable-next-line react/button-has-type
    <button
      {...props}
      className={classNames('group', props.className)}
      disabled={selectedAccount?.readonly || props.disabled}
    />
  );
};

export const Readonly = ({ children }: { children: ReactNode }) => {
  const { selectedAccount } = usePolkadot();

  return !selectedAccount?.readonly ? children : null;
};
